module.exports = __webpack_public_path__ + "static/media/slide3.3577542c.png";